export const shorten = (str: string, maxLen: number, separator = ' ') => {
    if (!str || str.length <= maxLen) return str
    return str.substr(0, str.lastIndexOf(separator, maxLen))
}
